export default __webpack_public_path__ + "static/media/KOD0156-min.80ca5dc8.webp";